import React, { PureComponent } from 'react';
import GlobalHelper from '../../../Common/Helpers/GlobalHelper';

class TableFooter extends PureComponent {
    constructor(props) { super(props); }

    render() {
        const { limitesCliente } = this.props;
        const descripcion = ((limitesCliente.LimiteSinAsignar) > 0 ? "Límite global sin asignar" : "Límite sobreasignados");

        return (
            <div className="row">
                <div className="col-md-1">
                </div>
                <div className="col-md-5">
                    <span className="icon-available-limit22"></span>
                    <label className="label-secondary left-separator-xxs">{descripcion}</label>
                </div>
                <div className="col-md-6">
                    <label className="label-secondary">${GlobalHelper.ConvertirNumeroSinDecimales(limitesCliente.LimiteSinAsignar)}</label>
                </div>
            </div>
        );
    }
}

export default TableFooter;